export const MegEvents = {};

MegEvents.hasActiveEvent = () => {
  return MegEvents.silentOnTheBridge()
}

MegEvents.displayHint = () => {
}

MegEvents.silentOnTheBridge = () => {
  // czy już drugi rozdział
  if(!EventStateService.secondChapterIntro) {
    return false;
  }

  return !EventStateService.silentOnTheBridge;
}

MegEvents.nightVisit = () => {
  // czy odbyła się rozmowa z Elianą w trzecim rozdziale
  if(!EventStateService.state.mcHome.chapter2EndEvent) {
    return false;
  }

  return !EventStateService.megNightVisit;
}
